export const scrollToBlockBehavior = 'smooth'
